import Resource from '@/api/core/resource'
import AppConfig from '@/config/appConfig'

class Auth extends Resource {
  constructor () {
    super('Users')
  }

  activateAccount (credentials) {
    return this.request.post(this.uri.concat('/ActivateAccount'),credentials)
  }

  createAccount (credentials) {
    return this.request.post(this.uri.concat('/create'), credentials)
  }
  
  login (credentials) {
    return this.request.post(this.uri.concat('/login'), credentials)
  }

  generateCode (generateCodeModel) {
    return this.request.post(this.uri.concat('/GenerateVerificationCode'),generateCodeModel)
  }

  setUserPhone (credentials) {
    return this.request.post(this.uri.concat('/setUserPhone') ,credentials)
  }

  user () {
    return this.request.get(this.uri.concat('/user'))
  }

  forgotPassword (credentials) {
    return this.request.post(this.uri.concat('/ForgotPassword'), credentials)
  }

  resetPassword (credentials) {
    return this.request.post(this.uri.concat('/ResetPassword'), credentials)
  }
}

export default new Auth()
